module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/6-f13d96cc3a1ff551ba497618acdc5e80.jpg";